import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { BASE_URL } from '../config/constants';
function Packages() {
	const [packages, setPackages] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [messageData, setMessageData] = useState([]); // Array to hold messages
	const [buyingPackageId, setBuyingPackageId] = useState(null); // State to track the package being purchased
	const token = Cookies.get('token');
	const baseUrl = BASE_URL;
	useEffect(() => {
		fetch(`${baseUrl}/api/v1/packages/public`)
			.then((res) => {
				if (!res.ok) {
					throw new Error(`HTTP error! status: ${res.status}`);
				}
				return res.json();
			})
			.then((data) => {
				setPackages(data);
				setError(null);
			})
			.catch((err) => {
				console.error('Error fetching packages data:', err);
				setError('Failed to fetch packages. Please try again later.');
			})
			.finally(() => {
				setLoading(false);
			});
	}, []);

	const handleBuyPackage = async (id) => {
		if (!token) {
			window.location.href = '/login';
			return;
		}

		setBuyingPackageId(id);

		const body = { packageId: id };

		try {
			const response = await fetch(`${baseUrl}/api/v1/transactions`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify(body),
			});

			const data = await response.json();

			if (response.ok) {
				if (data.redirectUrl) {
					window.open(data.redirectUrl, '_blank');
				}
			} else {
				const errorMessage =
					data?.errors?.data ||
					'An unexpected error occurred. Please try again.';
				setMessageData((prevMessages) => [
					...prevMessages.filter((msg) => msg.packageId !== id),
					{ packageId: id, message: errorMessage },
				]);
			}
		} catch (err) {
			setMessageData((prevMessages) => [
				...prevMessages.filter((msg) => msg.packageId !== id),
				{ packageId: id, message: 'Transaction failed. Please try again.' },
			]);
		} finally {
			setBuyingPackageId(null);
		}
	};

	return (
		<section>
			{loading ? (
				<p className='h-screen bg-main text-white font-bold text-2xl flex justify-center items-center'>
					Loading packages...
				</p>
			) : error ? (
				<p className='h-screen flex justify-center items-center text-red-500 text-2xl font-bold'>
					{error}
				</p>
			) : packages.length === 0 ? (
				<p className='h-screen bg-main text-white font-bold text-2xl flex justify-center items-center'>
					No packages available at the moment.
				</p>
			) : (
				<main className='container'>
					<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 p-6 gap-6'>
						{packages.map((pkg) => (
							<div
								key={pkg.id}
								className='card flex flex-col gap-4 rounded-lg border-2 border-solid border-main p-6'>
								<h2 className='text-lg text-secondary'>{pkg.name}</h2>
								<p className='text-textColor'>{pkg.description}</p>
								<div className='flex justify-between text-textColor'>
									<p className='text-lg text-main font-bold'>{pkg.price} $</p>
									<p>{pkg.duration} h</p>
								</div>
								<button
									onClick={() => handleBuyPackage(pkg.id)}
									className='mt-4 px-4 py-2 bg-main text-white rounded-lg'
									disabled={buyingPackageId === pkg.id}>
									{buyingPackageId === pkg.id ? 'Processing...' : 'Buy Package'}
								</button>

								{messageData
									.filter((msg) => msg.packageId === pkg.id)
									.map((msg, index) => (
										<p
											key={index}
											className={`mt-2 text-center ${
												msg.message.includes('successful')
													? 'text-green-600'
													: 'text-red-600'
											}`}>
											{msg.message}
										</p>
									))}
							</div>
						))}
					</div>
				</main>
			)}
		</section>
	);
}

export default Packages;
